// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import Router from 'next/router';
import TextInput from '@/components/text-input';
import Button from '@/components/button';
import StatusField from '@/components/status-field';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import StatusOptions from '@/components/modals/status-options';
import ToastContext from '@/utils/toast-context';
import { SketchPicker } from 'react-color';
import useOutsideClick from "@/hooks/useOutsideClick";
import SettingsMenu from '@/components/settings/menu';
import Checkbox from '@/components/checkbox';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import Reorder, { reorder } from 'react-reorder';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import constants from '@/utils/constants';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



function JobStatusSettings() {

  const toast = useContext(ToastContext);
  const { data: statusesData } = useQuery(['jobStatuses'], () => Fetch.get({ url: '/JobStatus' }));
  const [statuses, setStatuses] = useState<any[]>([]);

  useEffect(() => {
    if (statusesData?.Results) {
      setStatuses(statusesData.Results);
    }
  }, [statusesData]);
  const [submitting, setSubmitting] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<any>();
  const [statusName, setStatusName] = useState<any>();
  const [statusColor, setStatusColor] = useState('Black');
  const [closeStatus, setCloseStatus] = useState(false);
  const [selectedStatusOptions, setSelectedStatusOptions] = useState<any>();
  const [addingOptions, setAddingOptions] = useState(false);
  const [showPicker, setShowPicker] = useState(false);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, updateSettings);

  let currPath = "";
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const pickerRef = useRef<any>();
  useOutsideClick(pickerRef, () => {
    if (showPicker) {
      setShowPicker(false);
    }
  });

  //SUBMIT Updates
  async function updateSettings() {
    setSubmitting(true);

    let isNew = !selectedStatus.ID;
    let settingsUpdateResult;
    if (selectedStatus.ID) {
      settingsUpdateResult = await Fetch.put({
        url: '/JobStatus',
        params: {
          JobStatus: {
            ...selectedStatus,
            Description: statusName,
            DisplayColor: statusColor,
            CloseStatus: closeStatus,
          },
          JobStatusOptions: selectedStatusOptions
        },
        toastCtx: toast
      });
    } else {
      settingsUpdateResult = await Fetch.post({
        url: '/JobStatus',
        params: {
          JobStatus: {
            ...selectedStatus,
            Description: statusName,
            DisplayColor: statusColor,
            CloseStatus: closeStatus,
          },
          JobStatusOptions: selectedStatusOptions
        },
        toastCtx: toast
      });
    }

    if (settingsUpdateResult.ID) {

      if (isNew) {
        Helper.mixpanelTrack(constants.mixPanelEvents.createJobStatus, {
          "jobStatusID": settingsUpdateResult.ID
        });
      }

      toast.setToast!!!({
        message: 'Status updated successfully',
        show: true,
        type: 'success'
      });
    }

    const statuses = await Fetch.get({
      url: '/JobStatus',
      toastCtx: toast
    });
    setStatuses(statuses.Results);

    setSelectedStatus(undefined);
    setSelectedStatusOptions(undefined);


    setFormIsDirty(false);

    setSubmitting(false);
    return true;
  }

  async function deleteStatus() {

    setConfirmOptions({
      ...Helper.initialiseConfirmOptions(),
      display: true,
      confirmButtonText: "Delete",
      heading: "Confirm delete job status?",
      onConfirm: async () => {
        setSubmitting(true);

        if (selectedStatus.ID) {
          const deleteResult = await Fetch.destroy({
            url: '/JobStatus/' + selectedStatus.ID,
            params: {},
            toastCtx: toast
          });
          if (deleteResult) {
            setFormIsDirty(false);
            toast.setToast!!!({
              message: 'Status deleted successfully',
              show: true,
              type: 'success'
            })
          }
        }

        const statuses = await Fetch.get({
          url: '/JobStatus',
          toastCtx: toast
        });
        setStatuses(statuses.Results);

        setSelectedStatus(undefined);
        setSelectedStatusOptions(undefined);

        setFormIsDirty(false);

        setSubmitting(false);
      }
    });
  }

  async function getStatusOptions(status: any) {
    const statusOptionsResult = await getOptions(status);
    if (statusOptionsResult.Results) {
      setSelectedStatusOptions(statusOptionsResult.Results)
    }
  }

  function newStatus() {
    setStatusName("New Status");
    setStatusColor("Black");
    let options = []
    for (let i = 0; i < 51; i++) {
      options[i] = {
        JobStatusOptionName: i + 1,
        OptionConfiguration: 0,
        IsActive: false
      }
    }
    setSelectedStatusOptions(options)
    setSelectedStatus({
      CloseStatus: false,
      DisplayColor: 'Black',
      IsActive: true,
      Location: null,
      StatusNode: null,
      StatusOrder: statuses.length + 1,
      StartStatus: false,
    });
    setFormIsDirty(false);
  }

  useEffect(() => {
    if (selectedStatus) {
      getStatusOptions(selectedStatus);
      setStatusName(selectedStatus.Description);
      setStatusColor(selectedStatus.DisplayColor);
      setCloseStatus(selectedStatus.CloseStatus);
    }
  }, [selectedStatus]);

  function updateStatusOption(optionName: any, newValue: any) {
    let newStatusOptions = [...selectedStatusOptions];
    let editOption = newStatusOptions.find((option: any) => option.JobStatusOptionName == optionName)
    editOption.OptionConfiguration = newValue;
    setSelectedStatusOptions(newStatusOptions)
    setFormIsDirty(true);
  }

  function removeStatusOption(optionName: any, newValue: any) {

    let newStatusOptions = [...selectedStatusOptions]
    let changeOption = newStatusOptions.find((option: any) => option.JobStatusOptionName == optionName)
    changeOption.OptionConfiguration = 0;
    changeOption.IsActive = false;
    setSelectedStatusOptions(newStatusOptions)
    setFormIsDirty(true);
  }

  function saveOptions(addedOptions: any) {
    let newOptions = [
      ...selectedStatusOptions
    ]
    addedOptions.map(function (addedOption: any) {
      let changeOption = newOptions.find((option: any) => option.JobStatusOptionName == addedOption.JobStatusOptionName);
      changeOption.OptionConfiguration = 1;
      changeOption.IsActive = true;
    })
    setSelectedStatusOptions(newOptions);
    setAddingOptions(false);
    setFormIsDirty(true);
  }

  const [disableReorder, setReorderToDisabled] = useState(true);

  const updateOnReorder = async (status: any) => {

    let options = await getOptions(status);

    await Fetch.put({
      url: '/JobStatus',
      params: {
        JobStatus: status,
        JobStatusOptions: options.Results
      },
      toastCtx: toast
    });
  }

  const refetchData = async () => {
    const statuses = await Fetch.get({
      url: '/JobStatus',
      toastCtx: toast
    });
    setStatuses(statuses.Results);

    setSelectedStatus(undefined);
    setSelectedStatusOptions(undefined);
  }

  const getOptions = async (status: any) => {
    return await Fetch.get({
      url: '/JobStatus/JobStatusOption',
      params: {
        jobStatusID: status.ID
      }
    });
  }

  async function onReorder(event: any, previousIndex: any, nextIndex: any, fromId: any, toId: any) {

    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      return;
    }

    const temp = statuses[nextIndex].StatusOrder;
    statuses[nextIndex].StatusOrder = statuses[previousIndex].StatusOrder;
    statuses[previousIndex].StatusOrder = temp;
    setStatuses(reorder(statuses, previousIndex, nextIndex));

    await updateOnReorder(statuses[nextIndex]);
    await updateOnReorder(statuses[previousIndex]);

    refetchData();
  }

  return (
    <div className="settings-container">
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <h2>Job Settings</h2>
          <div className="section-title">
            Job Statuses
          </div>
          <div className="small-title">Created statuses</div>

          <div className="status-block">

            {!selectedStatus ? <>
              <Reorder reorderId="status-list" onReorder={onReorder} lock='horizontal' component='div'
                placeholderClassName='reorder-placeholder' draggedClassName='reorder-dragged' disabled={disableReorder}>
                {
                  statuses.map(function (status: any, index: any) {
                    const style = (status.DisplayColor
                      ? status.DisplayColor.includes('#')
                        ? { backgroundColor: Helper.hexToRgba(status.DisplayColor, 0.2), color: status.DisplayColor }
                        : {}
                      : {}
                    )

                    let statusContainerStyle = {};
                    if (selectedStatus) {
                      if (status.ID == selectedStatus.ID) {
                        statusContainerStyle = { border: `1px solid ${colors.bluePrimary}` };
                      }
                    }

                    return (
                      <div key={index} className="re-status-block">
                        <div className="move" title="Click and drag to reorder"
                          onMouseEnter={() => setReorderToDisabled(false)} onMouseLeave={() => setReorderToDisabled(true)}>
                          <img src="/icons/menu-light.svg" alt="move" />
                        </div>
                        <div className={`re-status-container`} onClick={() => { setSelectedStatus(status); setFormIsDirty(false); }} key={index} style={statusContainerStyle}>
                          <div className={`re-status ${status.DisplayColor}`} style={style}>
                            {status.Description}
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </Reorder>
            </> : ""}

            {selectedStatusOptions
              ? <div className="status-setup">
                <h1>Status set up</h1>
                {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess ? <>
                  <img src="/icons/trash-bluegrey.svg" alt="delete" onClick={deleteStatus} className="delete" />
                </> : ""}
                <Button text="Cancel" extraClasses="white-action fit-content cancel" onClick={() => {
                  setSelectedStatus(undefined);
                  setSelectedStatusOptions(undefined);
                  setFormIsDirty(false);
                  }} />
                <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                  text={submitting ? "Saving" : "Save"} extraClasses="fit-content save" onClick={updateSettings} />
                <div className="detail-row">
                  <div className="detail-column">
                    <div className="small-title">Status label</div>
                    <TextInput
                      changeHandler={(e: any) => { setStatusName(e.target.value); setFormIsDirty(true);}}
                      name="statusName"
                      placeholder={"Enter the name of the status"}
                      value={statusName}
                    />
                  </div>
                  <div className="detail-column">
                    <div className="small-title">Selected colour</div>
                    <div className={`color-block color-block-selected b-${statusColor}`}></div>
                  </div>
                  <div className="detail-column end">
                    <div className="small-title">Close Job</div>
                    <Checkbox
                      changeHandler={() => {setCloseStatus(!closeStatus); setFormIsDirty(true);}}
                      label=""
                      checked={closeStatus}
                      extraClasses="form"
                    />
                  </div>
                </div>
                <div className="small-title">Select status colour</div>
                <div className="row">
                  <div className="color-block b-Red" onClick={() => {setStatusColor('Red'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Orange" onClick={() => {setStatusColor('Orange'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Yellow" onClick={() => {setStatusColor('Yellow'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Green" onClick={() => {setStatusColor('Green'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Blue" onClick={() => {setStatusColor('Blue'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Purple" onClick={() => {setStatusColor('Purple'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Black" onClick={() => {setStatusColor('Black'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-Grey" onClick={() => {setStatusColor('Grey'); setFormIsDirty(true);}}></div>
                  <div className="color-block b-LightGrey" onClick={() => {setStatusColor('LightGrey'); setFormIsDirty(true);}}></div>
                  <div className="color-picker" ref={showPicker ? pickerRef : null}>
                    <div className="color-block add-color" onClick={() => setShowPicker(true)}>+</div>
                    {showPicker
                      ? <SketchPicker
                        disableAlpha={true}
                        color={statusColor}
                        onChangeComplete={(color: any) => {setStatusColor(color.hex); setFormIsDirty(true);}}
                        presetColors={[]}
                      />
                      : ''
                    }
                  </div>
                </div>
                <div className="small-title">Select required field for statuses</div>
                <div className="status-options">
                  {selectedStatusOptions.map(function (statusOption: any, index: any) {
                    return (
                      statusOption.IsActive
                        ? <StatusField statusOption={statusOption} key={index} updateStatusOption={updateStatusOption} deleteFunc={removeStatusOption} />
                        : ''
                    )
                  })}
                  <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                    text="Add field" icon="plus-circle" extraClasses="fit-content" onClick={() => setAddingOptions(true)} />
                </div>
                {addingOptions
                  ? <StatusOptions
                    availableOptions={selectedStatusOptions.filter((option: any) => option.IsActive != true)}
                    setAddingOptions={setAddingOptions}
                    saveOptions={saveOptions}
                  />
                  : ''
                }
              </div>
              : ''
            }

          </div>
          {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess && !selectedStatus ? <>
            <div className="status-add">
              <div className="status" onClick={newStatus}>
                <img src="/icons/plus-circle-blue.svg" alt="plus" />
                Add Status
              </div>
            </div>
          </> : ""}

        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .re-status-block {
          display: flex;
          width: 100%;
        }
        .re-status-container {
          display: flex;
          flex-direction: row;
          background-color: ${colors.white};
          border-radius: ${layout.buttonRadius};
          height: 3rem;
          margin: 1rem 0 0 1rem;
        }
        .re-status {
          align-items: center;
          background-color: rgba(28,37,44,0.2);
          border-radius: ${layout.buttonRadius};
          box-sizing: border-box;
          color: ${colors.darkPrimary};
          cursor: pointer;
          display: flex;
          width: 200px;
          font-size: 0.875rem;
          font-weight: bold;
          height: 3rem;
          justify-content: center;
          padding: 0 1rem;
          text-align: center;
        }
        .move {
          display: flex;
          align-items: center;
          cursor: move;
          margin-top: 1rem;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        p {
          color: ${colors.darkPrimary};
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .title {
          width: 100%;
          color: ${colors.darkPrimary};
        }
        .title h1 {
          font-size: 24px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .row {
          display: flex;
        }
        .space-between {
          justify-content: space-between;
        }
        .split {
          display: flex;
        }
        .detail-row {
          display: flex;
          margin-left: -1.5rem;
        }
        .detail-column {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          margin-left: 1.5rem;
          max-width: 50%;
        }
        .end {
          align-items: flex-end;
        }
        h2 {
          color: ${colors.darkPrimary};
          font-size: 1.75rem;
          font-weight: lighter;
          margin: 1rem 0 1rem;
        }
        .section-title {
          background-color: ${colors.background};
          border-radius: ${layout.cardRadius};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          color: ${colors.bluePrimary};
          font-size: 1.25rem;
          font-weight: bold;
          opacity: 0.9;
          padding: 1rem;
        }
        .small-title {
          color: ${colors.darkPrimary};
          font-size: 0.875rem;
          font-weight: bold;
          margin-top: 2rem;
        }
        .status-block {
          display: flex;
          width: 100%;
        }
        .status {
          align-items: center;
          background-color: rgba(28,37,44,0.2);
          border-radius: ${layout.buttonRadius};
          box-sizing: border-box;
          color: ${colors.darkPrimary};
          cursor: pointer;
          display: flex;
          width: 200px;
          font-size: 0.875rem;
          font-weight: bold;
          height: 3rem;
          justify-content: center;
          padding: 0 1rem;
          text-align: center;
        }
        .status-container {
          display: flex;
          flex-direction: row;
          background-color: ${colors.white};
          border-radius: ${layout.buttonRadius};
          height: 3rem;
          margin: 1rem 0 0 1rem;
        }
        .statuses {
          display: flex;
          flex-direction: column;
          width: fit-content;
          flex-wrap: wrap;
          margin: 0 1rem 1rem -1rem;
        }
        .status-add {
          background: none;
          border: 1px solid ${colors.bluePrimary};
          box-sizing: border-box;
          margin-left: 2.5rem;
          margin-top: 1rem;
          width: 200px;
        }
        .status-add img {
          margin-right: 0.5rem;
        }
        .status-add .status {
          background: none;
          color: ${colors.bluePrimary};
        }
        .status-setup {
          border: 1px solid ${colors.bluePrimary};
          border-radius: ${layout.cardRadius};
          margin-top: 1rem;
          margin-left: 1rem;
          padding: 1rem;
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .status-setup h1 {
          color: ${colors.darkPrimary};
          font-size: 1.5rem;
          font-weight: normal;
          margin: 0 0 0.5rem;
        }
        .status-setup :global(.save) {
          margin-top: 0px;
          position: absolute;
          right: 1rem;
          top: 1rem;
        }

        .status-setup :global(.cancel) {
          margin-top: 0px;
          position: absolute;
          right: 6rem;
          top: 1rem;
        }

        .status-setup :global(.delete) {
          cursor: pointer;
          margin-top: 0px;
          position: absolute;
          right: 12.5rem;
          top: 1.5rem;
        }
        .status-options {
          width: 100%;
        }
        .color-block {
          border-radius: ${layout.cardRadius};
          background-color: #4F4F4F;
          cursor: pointer;
          height: 2rem;
          margin-right: 1rem;
          margin-top: 1rem;
          position: relative;
          width: 2rem;
          z-index: 1;
        }
        .add-color {
          align-items: center;
          background: none;
          border: 1px solid ${colors.darkPrimary};
          color: ${colors.darkPrimary};
          display: flex;
          justify-content: center;
        }
        .color-block-selected {
          background-color: ${selectedStatus ? statusColor ? statusColor.includes('#') ? statusColor : "" : "" : ""};
        }
        .color-picker {
          position: relative;
        }
        .color-picker :global(.sketch-picker) {
          left: 0;
          position: absolute;
          top: calc(100% + 0.5rem);
          z-index: 99;
        }

        /*REMOVE DUPLICATE COLOR CODE*/
        .Red {
          background-color: rgba(252, 46, 80, 0.2); /*#FC2E50;*/
          color: #FC2E50 !important;
        }
        .b-Red {
          background-color: #FC2E50;
        }
        .Orange {
          background-color: rgba(242, 97, 1, 0.2);
          color: #F26101 !important;
        }
        .b-Orange {
          background-color: #F26101;
        }
        .Yellow {
          background-color: rgba(255, 201, 64, 0.2);
          color: #FFC940 !important;
        }
        .b-Yellow {
          background-color: #FFC940;
        }
        .Green {
          background-color: rgba(81, 203, 104, 0.2);
          color: #51CB68 !important;
        }
        .b-Green {
          background-color: #51CB68;
        }
        .Blue {
          background-color: rgba(90, 133, 225, 0.2);
          color: #5A85E1 !important;
        }
        .b-Blue {
          background-color: #5A85E1;
        }
        .Purple {
          background-color: rgba(128, 100, 250, 0.2);
          color: #735AE1 !important;
        }
        .b-Purple {
          background-color: #735AE1;
        }
        .Black {
          background-color: rgba(79, 79, 79, 0.2);
          color: #4F4F4F !important;
        }
        .b-Black {
          background-color: #4F4F4F;
        }
        .Grey {
          background-color: rgba(130, 130, 130, 0.2);
          color: #828282 !important;
        }
        .b-Grey {
          background-color: #828282;
        }
        .LightGrey {
          background-color: rgba(189, 189, 189, 0.2);
          color: #BDBDBD !important;
        }
        .b-LightGrey {
          background-color: #BDBDBD;
        }
      `}</style>
    </div>
  );
}

export default JobStatusSettings;

export const Route = createFileRoute('/_authenticated/settings/job-status')({ component: JobStatusSettings })
